import React from 'react';

export default function CautionaryInformationLearMore() {
  return (
    <div>
      <h3>Cautionary warnings and school closings</h3>
      <p>
        If any cautionary warnings have been issued, they will appear below. VA
        applies caution flags when we, or another federal agency, have increased
        regulatory or legal scrutiny of an educational program. We recommend
        students consider these warnings before enrolling in flagged programs.
      </p>
      <p>
        In addition, if the VA receives notice that a school or campus location
        will be closing, it will appear below. Once the closing date passes, we
        remove the institution from the Comparison Tool during the next system
        update.
      </p>
    </div>
  );
}
